import React from 'react'
import RegisterApp from '../../features/auth/Register'
export default function Register() {
  return (<RegisterApp/>)
}
